import { Link, useLocation } from "wouter";
import ENV from "@/utils/env";
import { Cog8ToothIcon, MoonIcon, UserIcon } from "@heroicons/react/24/solid";
import { ArrowRightStartOnRectangleIcon, ArrowTopRightOnSquareIcon, ChevronDownIcon, ComputerDesktopIcon, DevicePhoneMobileIcon } from "@heroicons/react/24/outline";
import { useGetSession } from "@/api/auth/queries";
import { ThemeSwitcher } from "@/theme/theme-switcher";
import { Avatar } from "@/components/ui/avatar";
import { CustomDropdown, CustomDropdownItem } from "@/components/ui/dropdown";
import { Logo } from "@/components/ui/logo";
import UserProfilePic from "@/assets/avatars/user-profile-pic.png";
import { WindowIcon } from "@heroicons/react/24/outline";
import { UserCircleIcon } from "@heroicons/react/20/solid";

/*
 * Header component
 */
export const Header = () => {
  /* Hooks */
  const { data: session, isLoading: isSessionLoading } = useGetSession();
  const [, navigate] = useLocation();

  /* Handlers */
  const handleSignout = () => {
    navigate("/auth/signout");
  };

  /* Constants */
  const fullName = isSessionLoading ? "Loading..." : session ? `${session?.user.firstName} ${session?.user.lastName}` : "Unknown user";

  /* Render */
  return (
    <header className="min-h-12 flex items-center justify-between pl-2">
      <Link href="/" className="flex items-center gap-2">
        <Logo /> <h3 className="font-semibold">Studio</h3>
      </Link>
      <div className="flex items-center gap-6">
        {/* <Tooltip content="Please refresh" offset={5} place="bottom" classNameArrow="" noArrow>
          <ArrowPathIcon className="size-5 text-base-content/50 cursor-pointer hover:animate-spin" />
        </Tooltip> */}
        <div className="flex items-center gap-2">
          <CustomDropdown
            align="end"
            listClassname="w-auto min-w-[320px]"
            triggerBtn={
              <div className="flex items-center gap-2 px-3">
                <UserIcon className="size-4" />
                <p className="text-sm text-base-content">{fullName}</p>
                <ChevronDownIcon className="size-4" />
              </div>
            }
            header={
              <div className="flex items-center gap-3 border-b border-base-300 py-3 px-2 mb-2">
                <Avatar imageUrl={UserProfilePic} />
                <div className="flex flex-col gap-1 truncate max-w-[220px]">
                  <p className="font-semibold text-base-content truncate">{session?.account.company}</p>
                  <p className="text-sm text-base-content/50 truncate">{session?.user.email}</p>
                </div>
              </div>
            }
          >
            <CustomDropdownItem className="flex items-center justify-start gap-2 w-full" href={`${ENV.ADMIN_URL}/profile/basic-info`}>
              <div className="flex items-center justify-start gap-2 w-full">
                <Cog8ToothIcon className="size-5 inline-block" /> Account settings
              </div>
              <ArrowTopRightOnSquareIcon className="size-5 text-base-content/50" />
            </CustomDropdownItem>
            <CustomDropdownItem className="flex items-center justify-start gap-2 w-full" href="/auth/signin">
              <div className="flex items-center justify-start gap-2 w-full">
                <UserCircleIcon className="size-5 inline-block" /> Switch account
              </div>
              {/* <ArrowTopRightOnSquareIcon className="size-5 text-base-content/50" /> */}
            </CustomDropdownItem>
            <div className="flex items-center justify-start gap-2 w-full">
              <li className="w-full">
                <div className="flex items-center gap-2 justify-between">
                  <span className="flex gap-2">
                    <MoonIcon className="size-5" />
                    Dark mode
                  </span>
                  <ThemeSwitcher />
                </div>
              </li>
            </div>
            <CustomDropdownItem className="flex items-center justify-start gap-2 w-full" href="https://academy.dragonflyai.co/en/articles/9901710-welcome-to-dragonfly-mobile">
              <DevicePhoneMobileIcon className="size-5" /> Download mobile app
            </CustomDropdownItem>
            <CustomDropdownItem
              className="flex items-center justify-start gap-2 w-full"
              href="https://academy.dragonflyai.co/en/articles/9909496-welcome-to-the-desktop-application"
            >
              <ComputerDesktopIcon className="size-5" /> Download desktop app
            </CustomDropdownItem>
            <CustomDropdownItem className="flex items-center justify-start gap-2 w-full" href={`${ENV.STUDIO_2_URL}`}>
              <WindowIcon className="size-5" /> Studio 2 (Legacy)
            </CustomDropdownItem>
            <CustomDropdownItem onClick={handleSignout} className="flex items-center justify-start gap-2 w-full">
              <ArrowRightStartOnRectangleIcon className="size-5" /> Sign out
            </CustomDropdownItem>
            <p className="text-xs text-right opacity-70 border-t border-base-300 w-full pt-2 mt-2">v{APP_VERSION}</p>
          </CustomDropdown>
        </div>
        {/* <ThemeSwitcher /> */}
      </div>
    </header>
  );
};
